import React from 'react';
import { useAppSelector } from "src/store/hooks";

import { Spin } from "antd";
import Pagination from "src/componets/Pagination";
import ListGrid from "./_ListGrid";
import ListTable from "./_ListTable";

interface propsInterface {
  limit: number;
  type?: 'list' | 'grid';
}

const _List = ({ limit, type = 'list' }: propsInterface) => {
  const count  = useAppSelector(state => state.mineCraft.serverPlans.count);
  const error  = useAppSelector(state => state.mineCraft.serverPlans.error);
  const status = useAppSelector(state => state.mineCraft.serverPlans.status);

  if (status === 'loading') {
    return <Spin />;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      {type === 'grid' ? <ListGrid /> : <ListTable />}

      <Pagination className='v-mt-10' total={count} size={limit} />
    </>
  );
}

export default _List;
